import { render, staticRenderFns } from "./PackagingOptions.vue?vue&type=template&id=5fc98b7a&scoped=true"
import script from "./PackagingOptions.vue?vue&type=script&lang=js"
export * from "./PackagingOptions.vue?vue&type=script&lang=js"
import style0 from "./PackagingOptions.vue?vue&type=style&index=0&id=5fc98b7a&prod&scoped=true&lang=css"
import style1 from "./PackagingOptions.vue?vue&type=style&index=1&id=5fc98b7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc98b7a",
  null
  
)

export default component.exports